/* Preserve newsletter and FAQ links from the original Häkelnmuster theme.
   Shopify can change a template's numeric prefix when a theme is uploaded.
   Resolve only the original block/section pairs and leave the URL untouched. */
(() => {
  'use strict';

  const legacyBlocks = new Map([
    ['collapsible_row_RGpmDh', 'collapsible_content_meqRPJ'],
    ['collapsible_row_xMey8U', 'collapsible_content_meqRPJ'],
    ['collapsible_row_GWyTDp', 'collapsible_content_meqRPJ'],
    ['collapsible_row_ietFkJ', 'collapsible_content_eHmMh9'],
    ['collapsible_row_LD9BiP', 'collapsible_content_eHmMh9'],
    ['collapsible_row_EXjqxz', 'collapsible_content_eHmMh9'],
  ]);
  const legacySections = new Set(legacyBlocks.values());
  const blockFragment = /^(?:(?:Details|Summary|CollapsibleAccordion)-)?(collapsible_row_[A-Za-z0-9]+)(?:-((?:template--\d+__)?collapsible_content_[A-Za-z0-9]+))?$/;
  const sectionFragment = /^(?:shopify-section-)?(?:template--\d+__)?(collapsible_content_[A-Za-z0-9]+)$/;

  function restoreLegacyAnchor() {
    // An enabled native footer form owns ContactFooter. Keep the HM alias only
    // when no other element provides that original target.
    const nativeNewsletter = document.querySelector('[id="ContactFooter"]:not([data-hm-newsletter-alias])');
    document.querySelectorAll('[data-hm-newsletter-alias]').forEach((alias, index) => {
      if (nativeNewsletter || index > 0) {
        alias.removeAttribute('id');
      } else {
        alias.id = 'ContactFooter';
      }
    });

    let fragment;
    try {
      fragment = decodeURIComponent(window.location.hash.slice(1));
    } catch {
      return;
    }

    const blockMatch = blockFragment.exec(fragment);
    let target;

    if (fragment === 'ContactFooter') {
      target = document.getElementById('ContactFooter');
    } else if (blockMatch) {
      const [, blockId, qualifiedSection] = blockMatch;
      const sectionId = legacyBlocks.get(blockId);
      if (!sectionId || (qualifiedSection && qualifiedSection.split('__').pop() !== sectionId)) return;

      const section = document.querySelector(`[data-hm-legacy-faq-section="${sectionId}"]`);
      const details = section?.querySelector(`details[data-hm-legacy-faq-block="${blockId}"]`);
      if (!details) return;

      details.open = true;
      target = details.querySelector('summary');
      target?.setAttribute('aria-expanded', 'true');
    } else {
      const sectionId = sectionFragment.exec(fragment)?.[1];
      if (!legacySections.has(sectionId)) return;
      target = document.querySelector(`[data-hm-legacy-faq-section="${sectionId}"]`);
    }

    if (!target) return;
    target.scrollIntoView({ block: 'center', behavior: 'auto' });
    if (target.tagName === 'SUMMARY') target.focus({ preventScroll: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restoreLegacyAnchor, { once: true });
  } else {
    restoreLegacyAnchor();
  }
  window.addEventListener('hashchange', restoreLegacyAnchor);
  document.addEventListener('shopify:section:load', restoreLegacyAnchor);
})();
